import { render } from "./DjAbnormalTab.vue?vue&type=template&id=ac5d47da&scoped=true"
import script from "./DjAbnormalTab.vue?vue&type=script&lang=js"
export * from "./DjAbnormalTab.vue?vue&type=script&lang=js"

import "./DjAbnormalTab.vue?vue&type=style&index=0&id=ac5d47da&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ac5d47da"

export default script